import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const aunoaLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#7671F9',
      light: '#9B97FA',
      dark: '#5550D9',
    },
    secondary: {
      main: '#F04E7A',
      light: '#F47A9B',
      dark: '#C83D62',
    },
    navigation: {
      background: '#1D1F50',
      indicator: '#7671F9',
      color: '#C1D8FC',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#2A2D6A',
      },
    },
    background: {
      default: '#F5F6FA',
      paper: '#FFFFFF',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: ['#1D1F50', '#7671F9'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#1D1F50', '#81B1FA'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#1D1F50', '#F04E7A'],
      shape: shapes.round,
    }),
    other: genPageTheme({
      colors: ['#1D1F50', '#7671F9'],
      shape: shapes.wave,
    }),
  },
  fontFamily: '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
  components: {
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          background: '#1D1F50',
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'linear-gradient(135deg, #5550D9 0%, #9B97FA 100%)',
          boxShadow: '0 2px 4px rgba(85, 80, 217, 0.25)',
        },
      },
    },
    // Nota: los overrides para techdocs (header slim, toolbar collapse,
    // body.aunoa-techdocs-active) están en
    // `components/techdocs/TechDocsCustomStyles.tsx` y se inyectan en
    // document.head en runtime. MuiCssBaseline.styleOverrides con
    // template string no llega a generar reglas — el path correcto
    // es el style injection desde el addon.
  },
});

export const aunoaDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: '#9B97FA',
      light: '#B5B2FB',
      dark: '#7671F9',
    },
    secondary: {
      main: '#F47A9B',
      light: '#F7A0B5',
      dark: '#F04E7A',
    },
    navigation: {
      background: '#0F1035',
      indicator: '#7671F9',
      color: '#C1D8FC',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#1D1F50',
      },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: ['#1D1F50', '#7671F9'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#1D1F50', '#81B1FA'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#1D1F50', '#F04E7A'],
      shape: shapes.round,
    }),
    other: genPageTheme({
      colors: ['#1D1F50', '#7671F9'],
      shape: shapes.wave,
    }),
  },
  fontFamily: '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
  components: {
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          background: '#0F1035',
        },
      },
    },
    // Overrides para techdocs en TechDocsCustomStyles.tsx (light theme).
    // Dark theme hereda esa misma capa (la clase body es la misma).
  },
});
